export default __webpack_public_path__ + "static/19_33-e4d172843d7f38a42dbbe47f10fb4930.png";